import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SIGNING_MODAL_TYPES } from '../global-meta-data';

@Component({
  selector: 'app-resend-docs-link',
  templateUrl: './resend-docs-link.component.html',
  styleUrls: ['./resend-docs-link.component.scss']
})
export class ResendDocsLinkComponent implements OnInit {
  @Input() buttonType: 'resend' | 'remind' = 'resend';
  @Output() resendDocForSignEvent = new EventEmitter<string>();
  @Output() remindSignatoriesEvent = new EventEmitter<boolean>();

  constructor() { }

  /**
   * OnInit Lifecycle hook
   */
  ngOnInit() {
  }

  /**
   * Emit resend for sign event on resend button click
   */
  resendForSign() {
    this.resendDocForSignEvent.emit(SIGNING_MODAL_TYPES.RESEND);
  }

  /**
   * Emit remind signatories event on remind btn click
   */
  remindSignatory() {
    this.remindSignatoriesEvent.emit(true);
  }
}
